import React, { useEffect } from 'react';
import { motion } from "framer-motion";
import Canvas from './Canvas';

const About = props => {
  const setCanvas = props.setCanvas;
  const token = props.tokenList[0];
    useEffect(()=>{
      setCanvas({enabled:false, display:"background", token:token});
    },[setCanvas, token]);
    return (
      <>
      <motion.div 
        className="container has-text-black sp-about"
        initial={{y:50, opacity:0}}
        animate={{y:0, opacity:1}}
        transition={{delay:0.1, duration:0.5}}
      > 


        <section className="section">
          <p className="is-size-2 is-size-4-mobile">
          Spectron is a limited edition of abstract video experiments generated on the blockchain and inspired by my research on early video synthesizers. 
          </p>
        </section>

        <section className="section mt-4">  
          <p className="is-size-4 is-size-5-mobile is-family-secondary">
          When a new piece is minted, a unique video is procedurally generated following a set of rules defined by the artist and it is transferred to you. 
          The process happens on the blockchain, this means that the videos are immutable and always accessible. 
          After the 400 different pieces are sold, it will be no longer possible to generate new videos.</p>
          </section>
          <section className="section  mt-4 sp-about">
            <Canvas token={props.tokenList[399]} display="about" />
            <p className="sp-label mt-4">Spectron {props.tokenList[399].id}: last generated video.</p>
        </section>
          <section className="section">  
          <p className="is-size-4 is-size-5-mobile is-family-secondary mt-5">

This edition is the result of my experiments and researches in video art from the 60s and 70s, especially early analog video synthesizers. These were heavy hardware machines capable of generating shapes and patterns from the ground up, with no external visual input. The artist created its compositions by only modulating and combining electronic signals, in the same way musicians used audio synthesizers to generate electronic music. An assemblage of electronic pulsations.
          </p>
        </section>

      
    

        <section className="section  mt-4 ">
              <p className="is-size-2 is-size-4-mobile">
              «The signal is the clay for the potter and the paint for the painter: for us is the signal, the art material»
              </p>
              <p className="sp-label mt-4">From an interview to Woody Vasulka, video art pioneer</p>
        </section>
    
        <section className="section  mt-4">  
          <p className="is-size-4 is-size-5-mobile is-family-secondary">
          The distinctive aesthetic of the analog electronic image and the procedural approach to real time video manipulation was fascinating, but the hands-on approach is what really led me to investigate further. 
          
          I eventually became interested in the process as much as in the output. How were these machines able to generate such complexity by just manipulating electronic voltage? With my surprise, I discovered that early electronic schemes and hand-written documentation of these devices were available on-line. They were released with an early <a href="http://www.anyma.ch/blogs/research/wp-content/uploads/2010/09/distributed_religion.png" target="_blank" rel="noreferrer" className="has-text-black sp-em">open source license</a> already in the 70s! Although with modern technologies, Spectron shares its logic with its ancestors.</p>
          </section>

    
          <section className="section sp-about">
          <figure className="image"><img src={`${process.env.PUBLIC_URL}/img/stephen_beck.jpg`} alt="Artist Stephen Beck operating his Direct Video Synthesizer"/></figure>
          <p className="sp-label mt-5">Video artist Stephen Beck operating his Direct Video Synthesizer</p>

        </section>

          <section className="section ">
          <p className="is-size-4 is-size-5-mobile is-family-secondary">
          This project is built on top of <a href="http://artblocks.io" target="_blank" rel="noreferrer" className="has-text-black sp-em">ArtBlocks.io</a>, a decentralized application for generative art. This project wouldn't have been possible without the platform and without the help of its founder Erick.</p>
           
          <p className="is-size-4 is-size-5-mobile is-family-secondary mt-5">Spectron is, in particular, inspired by the EMS Spectre, an instrument from 1974 that combined analog signals with digital logic. It was notably used by Hayao Yamaneko (a pseudonym for Chris Marker) in his masterpiece film Sans Soleil. 
          </p>
        </section>
     

        <footer className=" section has-text-black columns is-mobile mt-4">
        <div className="column is-6 has-text-left pb-6">
        <p className="sp-label">Credits</p>
            <p className="is-size-7">The project Spectron has been ideated, curated and developed by <a href="https://twitter.com/simondemai" rel="noreferrer" target="_blank" className="has-text-black" >Simon De Mai</a>.</p>
        </div>

        <div className="column is-6 has-text-left pb-6">
        <p className="sp-label">Contact</p>

            <p className="is-size-7">Please get in touch! You can find me on <a href="https://twitter.com/simondemai" rel="noreferrer" target="_blank" className="has-text-black">Twitter</a> or on the <a href="https://discord.gg/T5MrnDKx" rel="noreferrer" target="_blank" className="has-text-black">Artblocks Discord</a> channel.</p>
        </div>

      

      </footer>
      </motion.div>
    
     
      </>
    )
  };
  
  export default About;